import React, { Component } from 'react';
import Loading from 'components/common/Loading';
import EditEventDetails from 'components/calendar/EditEventDetails';

class EventEdit extends Component {
  render() {
    const { event } = this.props;
    if (!event || event.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    return <EditEventDetails event={event} />;
  }
}

export default EventEdit;



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventEdit.js